module.exports = __webpack_public_path__ + "img/zfb2.9e77a495.jpg";